import { Coordinate } from "ol/coordinate";
import BaseEvent from "ol/events/Event";
import { Pixel } from "ol/pixel";

export enum ContextMenuEventType {
    RequestShow = 'requestshow',
    RequestHide = 'requesthide',
    Command = 'command'
}

export default class ContextMenuEvent extends BaseEvent {
    coordinate: Coordinate
    pixel: Pixel
    constructor(type: ContextMenuEventType, pixel: Pixel, coordinate: Coordinate) {
        super(type)
        this.coordinate = coordinate
        this.pixel = pixel
    }
}